// import React, { useState } from 'react';
// import { ThumbsUp, ThumbsDown, MessageSquare } from 'lucide-react';
// import { Button } from "./ui/button";
// import { Textarea } from "./ui/textarea";
// import { Card, CardContent } from "./ui/card";

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://smart-info-hub-api.mpix.my.id';

// const FeedbackWidget = ({ query, onFeedbackSent }) => {
//     const [step, setStep] = useState('rating'); // rating | comment | done
//     const [isSatisfied, setIsSatisfied] = useState(null);
//     const [comment, setComment] = useState('');
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     const handleRating = (satisfied) => {
//         setIsSatisfied(satisfied);
//         setStep('comment');
//     };

//     const handleSubmit = async () => {
//         if (!query) return;

//         setIsSubmitting(true);
//         try {
//             await fetch(`${API_BASE_URL}/api/feedback`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ query, is_satisfied: isSatisfied, comment }),
//             });
//             setStep('done');
//             if (onFeedbackSent) onFeedbackSent();
//         } catch (error) {
//             console.error('Error sending feedback:', error);
//             // Tetap set done agar user tidak merasa error
//             setStep('done');
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     if (step === 'done') {
//         return (
//             <div className="bg-green-50 p-4 rounded-xl border border-green-100 text-center animate-in fade-in zoom-in duration-300 mt-6 mb-8 max-w-2xl mx-auto">
//                 <p className="text-green-700 font-medium">Terima kasih atas masukan Anda!</p>
//             </div>
//         );
//     }

//     return (
//         <Card className="bg-white/80 backdrop-blur-sm border-blue-100 shadow-sm mt-6 mb-8 max-w-2xl mx-auto overflow-hidden">
//             <CardContent className="p-6">
//                 <div className="text-center space-y-4">
//                     <h4 className="font-medium text-gray-900 flex items-center justify-center gap-2">
//                         <MessageSquare className="w-4 h-4 text-blue-500" />
//                         Apakah hasil pencarian ini membantu?
//                     </h4>

//                     {step === 'rating' && (
//                         <div className="flex justify-center gap-4">
//                             <Button
//                                 variant="outline"
//                                 className="gap-2 h-10 px-6 hover:bg-green-50 hover:text-green-600 hover:border-green-200 transition-all"
//                                 onClick={() => handleRating(true)}
//                             >
//                                 <ThumbsUp className="w-4 h-4" />
//                                 Ya, Puas
//                             </Button>
//                             <Button
//                                 variant="outline"
//                                 className="gap-2 h-10 px-6 hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition-all"
//                                 onClick={() => handleRating(false)}
//                             >
//                                 <ThumbsDown className="w-4 h-4" />
//                                 Tidak Puas
//                             </Button>
//                         </div>
//                     )}

//                     {step === 'comment' && (
//                         <div className="space-y-4 animate-in slide-in-from-bottom-2 fade-in">
//                             <Textarea
//                                 placeholder={isSatisfied ? "Apa yang paling membantu?" : "Apa yang kurang dari hasil ini? (Opsional)"}
//                                 value={comment}
//                                 onChange={(e) => setComment(e.target.value)}
//                                 className="min-h-[80px] bg-white"
//                             />
//                             <div className="flex justify-end gap-2">
//                                 <Button variant="ghost" size="sm" onClick={() => setStep('rating')}>Batal</Button>
//                                 <Button size="sm" onClick={handleSubmit} disabled={isSubmitting} className="bg-blue-600 hover:bg-blue-700 text-white">
//                                     {isSubmitting ? "Mengirim..." : "Kirim Masukan"}
//                                 </Button>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </CardContent>
//         </Card>
//     );
// };

// export default FeedbackWidget;

import React, { useState, useEffect } from 'react';
import { ThumbsUp, ThumbsDown, MessageSquare } from 'lucide-react';
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Card, CardContent } from "./ui/card";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://smart-info-hub-api.mpix.my.id';

const FeedbackWidget = ({ query, onFeedbackSent }) => {
    const [step, setStep] = useState('rating'); // rating | comment | done
    const [isSatisfied, setIsSatisfied] = useState(null);
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // RESET STATE KETIKA QUERY BERUBAH (Pencarian Baru)
    useEffect(() => {
        setStep('rating');
        setIsSatisfied(null);
        setComment('');
        setIsSubmitting(false);
    }, [query]);

    const handleRating = (satisfied) => {
        setIsSatisfied(satisfied);
        setStep('comment');
    };

    const handleSubmit = async () => {
        if (!query) return;

        setIsSubmitting(true);
        try {
            await fetch(`${API_BASE_URL}/api/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ query, is_satisfied: isSatisfied, comment }),
            });
            setStep('done');
            if (onFeedbackSent) onFeedbackSent();
        } catch (error) {
            console.error('Error sending feedback:', error);
            // Tetap set done agar user tidak merasa error
            setStep('done');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (step === 'done') {
        return (
            <div className="bg-green-50 p-4 rounded-xl border border-green-100 text-center animate-in fade-in zoom-in duration-300 mt-6 mb-8 max-w-2xl mx-auto">
                <p className="text-green-700 font-medium">Terima kasih atas masukan Anda!</p>
            </div>
        );
    }

    return (
        <Card className="bg-white/80 backdrop-blur-sm border-blue-100 shadow-sm mt-6 mb-8 max-w-2xl mx-auto overflow-hidden">
            <CardContent className="p-6">
                <div className="text-center space-y-4">
                    <h4 className="font-medium text-gray-900 flex items-center justify-center gap-2">
                        <MessageSquare className="w-4 h-4 text-blue-500" />
                        Apakah hasil pencarian ini membantu?
                    </h4>

                    {step === 'rating' && (
                        <div className="flex justify-center gap-4">
                            <Button
                                variant="outline"
                                className="gap-2 h-10 px-6 hover:bg-green-50 hover:text-green-600 hover:border-green-200 transition-all"
                                onClick={() => handleRating(true)}
                            >
                                <ThumbsUp className="w-4 h-4" />
                                Ya, Puas
                            </Button>
                            <Button
                                variant="outline"
                                className="gap-2 h-10 px-6 hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition-all"
                                onClick={() => handleRating(false)}
                            >
                                <ThumbsDown className="w-4 h-4" />
                                Tidak Puas
                            </Button>
                        </div>
                    )}

                    {step === 'comment' && (
                        <div className="space-y-4 animate-in slide-in-from-bottom-2 fade-in">
                            <Textarea
                                placeholder={isSatisfied ? "Apa yang paling membantu?" : "Apa yang kurang dari hasil ini? (Opsional)"}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                className="min-h-[80px] bg-white"
                            />
                            <div className="flex justify-end gap-2">
                                <Button variant="ghost" size="sm" onClick={() => setStep('rating')}>Batal</Button>
                                <Button size="sm" onClick={handleSubmit} disabled={isSubmitting} className="bg-blue-600 hover:bg-blue-700 text-white">
                                    {isSubmitting ? "Mengirim..." : "Kirim Masukan"}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default FeedbackWidget;